import React, { useState } from 'react';
import { Box, Typography, Slider } from '@mui/material';
import CartoonButton from '../../CartoonButton.component';

interface Props {
  submitted: boolean;
  onSubmit: (answer: number) => void;
}

const ClosestNumber: React.FC<Props> = ({ submitted, onSubmit }) => {
  const [value, setValue] = useState(50);

  if (submitted) return <SubmittedBadge label={`You picked ${value}`} />;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3, width: '100%', maxWidth: 380 }}>
      <Typography sx={labelStyle}>Pick a number between 1 and 100</Typography>
      <Typography sx={{ fontFamily: '"Comic Sans MS", cursive', fontSize: '3rem', fontWeight: 'bold', color: 'white', textShadow: '2px 2px 0 rgba(0,0,0,0.4)' }}>
        {value}
      </Typography>
      <Slider
        value={value}
        onChange={(_, v) => setValue(v as number)}
        min={1} max={100}
        sx={{ color: '#ff4081', '& .MuiSlider-thumb': { width: 28, height: 28, border: '3px solid #222' } }}
      />
      <CartoonButton variant="contained" onClick={() => onSubmit(value)} sx={{ background: '#ff4081' }}>
        Lock In!
      </CartoonButton>
    </Box>
  );
};

export default ClosestNumber;

export const SubmittedBadge: React.FC<{ label?: string }> = ({ label }) => (
  <Box sx={{ textAlign: 'center' }}>
    <Typography sx={{ fontFamily: '"Comic Sans MS", cursive', fontSize: '2rem', color: '#4caf50', fontWeight: 'bold', textShadow: '1px 1px 0 rgba(0,0,0,0.4)' }}>
      ✅ Submitted!
    </Typography>
    {label && (
      <Typography sx={{ fontFamily: '"Comic Sans MS", cursive', color: 'rgba(255,255,255,0.7)', mt: 1 }}>
        {label}
      </Typography>
    )}
    <Typography sx={{ fontFamily: '"Comic Sans MS", cursive', color: 'rgba(255,255,255,0.5)', fontSize: '0.85rem', mt: 1 }}>
      Waiting for others…
    </Typography>
  </Box>
);

export const labelStyle = {
  fontFamily: '"Comic Sans MS", cursive',
  fontWeight: 'bold', color: 'white', fontSize: '1.1rem',
  textShadow: '1px 1px 0 rgba(0,0,0,0.4)', textAlign: 'center' as const,
};
